module.exports = __webpack_public_path__ + "static/media/ball_2_6.da0d4dba.mp3";